import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {Navigate, Outlet} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {selectUserInfo} from "store/userSlice";
import {fetchCompany} from "store/companySlice";
import {selectAuthInfo} from "store/authSlice";
import {selectCompanyInfo} from "store/companySlice";

import NoActiveCompany from "containers/admin/NoActiveCompany";

const AdminLayout = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const isAuthenticated = !!localStorage.getItem("authToken");
  const authInfo = useSelector(selectAuthInfo);
  const userInfo = useSelector(selectUserInfo);
  const companyInfo = useSelector(selectCompanyInfo);
  const hasNoActiveCompany =
    companyInfo.status === "succeeded" &&
    companyInfo.companies.length === 0 &&
    !companyInfo.id;

  useEffect(() => {
    (authInfo.isUserLoggedIn || isAuthenticated) && dispatch(fetchCompany());
    authInfo.isUserLoggedIn && i18n.changeLanguage(userInfo.lang.split(/-|_/));
    
    // Clear invalid token if user is not authenticated
    if (authInfo.status === "error" && isAuthenticated) {
      localStorage.removeItem("authToken");
    }
  }, [dispatch, authInfo, isAuthenticated, userInfo.lang, i18n]);

  return authInfo.isUserLoggedIn || (isAuthenticated && authInfo.status !== "error") ? (
    hasNoActiveCompany ? <NoActiveCompany /> : <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export default AdminLayout;
